import {Injectable} from '@angular/core';
import {Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {AngularFireAuth} from 'angularfire2/auth';
import {FirebaseUserService} from '../services/firebase/user.service';
import {Observable} from 'rxjs/Observable';
import {Subscription} from 'rxjs/Subscription';


@Injectable()
export class OrganizationStateGuard implements CanActivate {

  constructor(private auth: AngularFireAuth,
              private router: Router,
              private userService: FirebaseUserService) {
    console.log('Start OrganizationGuard');
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const authuser = this.auth.auth.currentUser;
    console.log('User: ', authuser);
    if (authuser) {
      return this.userService.getUserByUID(authuser.uid)
        .map(user => {
          console.log('User Org Guard: ', user);
          if (!user) {
            this.router.navigate(['/login']);
            console.log('false')
            return false;
          }
          const role = user.role;
          if (role !== 'org') {
            this.router.navigate(['/login']);
            return false;
          } else {
            console.log('true' , user.role);
            return true;
          }
        });
    } else {
      this.router.navigate(['/login']);
    }
  }

}





// WEBPACK FOOTER //
// C:/Clients/rent-hero/web-application/src/app/_shared/guards/organizationState.guard.ts